import remarkGfm from 'remark-gfm'

/**
 * Remark-tillägg för all markdown på sajten.
 *
 * `react-markdown` följer som standard CommonMark, som INTE har tabeller.
 * Utan GFM renderas en markdown-tabell som löptext full av vertikalstreck —
 * vilket den gjorde i lärarhandledningens bedömningsstöd, trots att tabellerna
 * redan hade stilar i `.dokument`. GFM ger också genomstruken text och
 * automatiska länkar.
 *
 * Listan delas av alla ReactMarkdown-anrop så att markdown betyder samma sak
 * i kapiteltext, kursplan, bildspel och lärarhandledning.
 */
export const MARKDOWN_TILLAGG = [remarkGfm]
